var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 25,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.515h-1.231a8.905 8.905 0 00-1.156-2.777l.872-.87a1.99 1.99 0 00-.024-2.796 2.004 2.004 0 00-2.804-.024l-.872.87A8.957 8.957 0 0014 3.765V2.537c0-1.101-.895-1.994-2-1.994s-2 .893-2 1.994v1.228a8.957 8.957 0 00-2.785 1.153l-.872-.87c-.785-.756-2.032-.745-2.804.024s-.782 2.014-.024 2.796l.872.87a8.905 8.905 0 00-1.156 2.777H2c-1.105 0-2 .893-2 1.995 0 1.101.895 1.994 2 1.994h1.231a8.905 8.905 0 001.156 2.777l-.872.87c-.758.783-.747 2.027.024 2.796s2.02.78 2.804.024l.872-.87A8.957 8.957 0 0010 21.255v1.228c0 1.102.895 1.994 2 1.994s2-.892 2-1.994v-1.228a8.957 8.957 0 002.785-1.152l.872.87a2.004 2.004 0 002.804-.025 1.99 1.99 0 00.024-2.796l-.872-.87a8.905 8.905 0 001.156-2.777H22c1.105 0 2-.893 2-1.994a1.997 1.997 0 00-2-1.995zM12 16.5c-2.21 0-4-1.786-4-3.99s1.79-3.988 4-3.988 4 1.786 4 3.989a3.983 3.983 0 01-1.172 2.82A4.006 4.006 0 0112 16.5z",
    fill: "#1868fb"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsActive);
export default __webpack_public_path__ + "static/media/settings-active.33041e8a.svg";
export { ForwardRef as ReactComponent };